module.exports = __webpack_public_path__ + "static/media/EduservicesLogo.71ce552c.jpg";